import FilterTags from '@components/filter-tags/FilterTags';
import { usePublicNotices, useTableStore } from '@stores';
import { getStateNameFromCode } from '@utils/helpers';
import { LookupQueries, LOOKUP_QUERY_KEYS } from '@api/services/lookup';
import { useQuery } from '@tanstack/react-query';
import { useNavigate } from '@tanstack/react-router';
import { buildPublicNoticesSearch } from './publicNoticeHelpers';

import { publicNoticesTableId } from '@pages/PublicNotices/public-notices-table/PublicNoticesTable';

const PublicNoticeFilterTags = () => {
  const navigate = useNavigate();

  const { setPageNumber } = useTableStore();
  const { districtCodes, searchText, stateCodes, setDistrictCodes, setSearchText, setStateCodes } = usePublicNotices();

  const { data: districtsData } = useQuery({
    queryKey: [LOOKUP_QUERY_KEYS.GET_DISTRICTS],
    queryFn: LookupQueries.getDistricts,
  });

  const updatePublicNoticesUrl = ({
    nextDistrictCodes = districtCodes,
    nextStateCodes = stateCodes,
    nextSearchText = searchText,
  }) => {
    navigate({
      to: '/public-notices',
      search: () =>
        buildPublicNoticesSearch({
          districtCodes: nextDistrictCodes,
          stateCodes: nextStateCodes,
          pageNumber: 1,
          searchText: nextSearchText,
        }),
      replace: true,
    });
  };

  const states = stateCodes.map((code) => getStateNameFromCode(code));
  const districts = districtCodes.map((code) => districtsData?.[code]?.orgName ?? code).filter(Boolean);

  const filters = {
    Districts: districts,
    States: states,
    Search: searchText,
  };

  const handleRemoveFilter = (filterType, filterValue) => {
    setPageNumber(publicNoticesTableId, 1);
    switch (filterType) {
      case 'Districts': {
        const nextDistrictCodes = districtCodes.filter((code) => districtsData?.[code]?.orgName !== filterValue);
        setDistrictCodes(nextDistrictCodes);
        updatePublicNoticesUrl({ nextDistrictCodes });
        break;
      }
      case 'States': {
        const nextStateCodes = stateCodes.filter((code) => getStateNameFromCode(code) !== filterValue);
        setStateCodes(nextStateCodes);
        updatePublicNoticesUrl({ nextStateCodes });
        break;
      }
      case 'Search':
        setSearchText('');
        updatePublicNoticesUrl({ nextSearchText: '' });
        break;
      default:
        break;
    }
  };

  const handleClearFilterType = (filterType) => {
    setPageNumber(publicNoticesTableId, 1);
    switch (filterType) {
      case 'Districts':
        setDistrictCodes([]);
        updatePublicNoticesUrl({ nextDistrictCodes: [] });
        break;
      case 'States':
        setStateCodes([]);
        updatePublicNoticesUrl({ nextStateCodes: [] });
        break;
      case 'Search':
        setSearchText('');
        updatePublicNoticesUrl({ nextSearchText: '' });
        break;
      default:
        break;
    }
  };

  return <FilterTags filters={filters} onRemoveFilter={handleRemoveFilter} onClearFilterType={handleClearFilterType} />;
};

export default PublicNoticeFilterTags;
